import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M7.75 7a4.25 4.25 0 1 1 7.999 2.005 6.5 6.5 0 0 1 1.544.245 5.75 5.75 0 1 0-7.466 3.075 6.5 6.5 0 0 1 .923-1.262A4.25 4.25 0 0 1 7.75 7m1.306 7.646C5.41 15.652 2.66 18.48 2.66 22a.75.75 0 0 0 1.5 0c0-2.534 1.96-4.84 4.878-5.791a6.6 6.6 0 0 1 .018-1.563m10.561 5.884c.146.475.223.968.223 1.47a.75.75 0 0 0 1.5 0c0-.956-.203-1.861-.571-2.693-.33.456-.717.867-1.152 1.223",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M15.5 9a6.5 6.5 0 1 1 0 13 6.5 6.5 0 0 1 0-13",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-width": "1.5",
      d: "m13.202 17.798 4.596-4.596M17.798 17.798l-4.596-4.596"
    }, null, -1)
  ]))]))
}
export default { render: render }